import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=509b817d&scoped=true"
import script from "./registered.vue?vue&type=script&lang=js"
export * from "./registered.vue?vue&type=script&lang=js"
import style0 from "./registered.vue?vue&type=style&index=0&id=509b817d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b817d",
  null
  
)

export default component.exports